// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__1i7GM","loadingShrink":"PageLoading_loadingShrink__3W5YV"};